"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIDEBAR_POPUP_HEIGHT = exports.SIDEBAR_POPUP_WIDTH = void 0;
exports.SIDEBAR_POPUP_WIDTH = 1280;
exports.SIDEBAR_POPUP_HEIGHT = 800;
